export default __webpack_public_path__ + "static/media/paulo-roberto.9f8ab1f7.jpg";